// src/pages/team.js
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import "./team.css";

const Team = () => {
  return (
    <div className="team-page-container app-content">
      <Navbar />

      {/* Team Section */}
      <section className="about-team">
        <motion.div
          className="team-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>Leadership Team</h2>
          <div className="underline"></div>
          <p>
            Our leadership team brings together decades of experience in artificial intelligence,
            cybersecurity, healthcare IT, and defense technology. With backgrounds ranging from the
            Department of Defense and intelligence agencies to leading research institutions and
            healthcare organizations, our team understands the critical intersection of security,
            compliance, and innovation.
          </p>
        </motion.div>

        <div className="team-grid">
          {[
            {
              name: "Dabis Camero",
              role: "Innovative Leader in AI/ML, Cybersecurity, and IAM Solutions ",
              desc: "AI/ML and Cybersecurity expert specializing in IAM, IGA, and next-gen security solutions",
            },
            {
              name: "Peter Kuchnia",
              role:
                "Director of Cybersecurity | Cyber Risk Management & Resilience | Cyber Strategic Advisor",
              desc: "Cybersecurity expert helping businesses stay secure with IAM, risk management, and cyber resilience",
            },
            {
              name: "Dr. Jason Elroy Martis",
              role: "Associate Professor",
              desc: "Expert in Deep Learning, Computer Vision, and AI with 15+ years of research and teaching experience",
            },
            {
              name: "Dr. Sannidhan M S",
              role: "Associate Professor",
              desc: "Expert in Image Processing, Machine Learning, and Quantum AI, with a strong passion for research and teaching",
            },
          ].map((member, idx) => (
            <motion.div
              key={member.name}
              className="team-member"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div className="member-photo"></div>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <span>{member.desc}</span>
            </motion.div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Team;
